module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Notifications1-d3d041c33bdca009b23b5d288771f422.svg";